import {
    ArrayFormItem, IArrayFormItemProps,
    IFormItemElement,
} from "../model/FormModel";
import React, {DetailedHTMLProps, HTMLAttributes, InputHTMLAttributes, RefAttributes} from "react";
import {IonCheckbox} from "@ionic/react";
import {StyleReactProps} from "@ionic/react/dist/types/components/react-component-lib/interfaces";
import ErrorWrapperFE from "../form-element/ErrorWrapperFE";
import {JSX} from "react/jsx-runtime";
import IntrinsicAttributes = JSX.IntrinsicAttributes;
import SimpleChoice from "../../../../ts/common/SimpleChoiceVO";

interface IProps extends IFormItemElement
{
    formItemProps:IArrayFormItemProps;
    choiceList?:SimpleChoice[];
    elementProps?: DetailedHTMLProps<InputHTMLAttributes<HTMLFieldSetElement>, HTMLFieldSetElement>
    checkboxProps?: IntrinsicAttributes & React.ComponentProps<typeof IonCheckbox> & Omit<HTMLAttributes<HTMLIonCheckboxElement>, "style"> & StyleReactProps & RefAttributes<typeof IonCheckbox>
}

const CheckboxGroupFIE = (props: IProps) =>
{
    let {
        form,
        formItemProps,
        label,
        onItemChange,
        children,
        instructions,
        elementProps,
        checkboxProps
    } = props;


    if(props.choiceList){

        const validValues: any[] = [];
        for(let choice of props.choiceList){
            validValues.push(choice.id)
        }
        if(validValues.length){
            formItemProps.validValues = validValues;
        }
    } else {
        formItemProps.validValues = null;
    }

    const formItem = form.requireFormItem(formItemProps, "array", true) as ArrayFormItem;

    label = label ?? formItem.name;
    label = label || !formItem.required ? label : " ";

    const onChange = (event:CustomEvent, choice:SimpleChoice) => {
        const checked = !!event.detail.checked;
        if(checked){
            formItem.addChildValue(choice.id.toString())
        } else {
            formItem.removeChildValue(choice.id.toString())
        }

        if(onItemChange){
            onItemChange(formItem.itemID)
        } else if(onItemChange !== null){
            form.onFormItemChange(formItem.itemID)
        }
    }
    return <div className={form.isFormItemHidden(formItem) ? "d-none" : ""}>
        <ErrorWrapperFE
            formItem={formItem}
        >
            <fieldset
                data-form-item-id={formItem.itemID}
                {...elementProps}
            >
                {!!label &&
                    <legend
                        className={"form-item-label" + (formItem.required ? " required" : "")}
                    >
                        {label}
                        <input id={formItem.itemID} className="d-none"/>
                    </legend>
                }
                {!!instructions && (
                    <span className="instructions mb-3">{instructions}</span>
                )}
                <div className="row d-flex align-items-start row-cols-2 row-cols-md-3 row-cols-lg-4 g-3">
                    {!!props.choiceList && props.choiceList.map((choice, index) =>
                    {
                        return <div
                            className="col-12"
                            key={index}
                        >
                            <div className="radio_check-el">
                                <IonCheckbox
                                    {...checkboxProps}
                                    labelPlacement={checkboxProps?.labelPlacement ?? "end"}
                                    name={choice.id.toString()}
                                    checked={(formItem.value ?? []).includes(choice.id.toString())}
                                    onIonChange={(event) => onChange(event, choice)}
                                >
                                    {choice.name}
                                </IonCheckbox>
                            </div>
                        </div>
                    })}
                    {!!children && (
                        <div className="col-12">
                            {children}
                        </div>
                    )}
                </div>
            </fieldset>
        </ErrorWrapperFE>
    </div>;
}

export default CheckboxGroupFIE;